import {
  deleteDataAPI,
  getDataAPI,
  postDataAPI,
} from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

const adminToken = () => localStorage.getItem("adminToken");

const fail = (error, fallback) => {
  errorAlert(error.response?.data?.message || fallback);
  return false;
};

/* -------------------------------- admin -------------------------------- */

export const getPoliciesAdmin = (params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams(params).toString();
    const response = await dispatch(
      getDataAPI(`admin/policy/list${q ? `?${q}` : ""}`, adminToken())
    );
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const savePolicy = (data, id) => async (dispatch) => {
  try {
    const url = id ? `admin/policy/update/${id}` : "admin/policy/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The policy could not be saved.");
  }
};

export const deletePolicy = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/policy/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The policy could not be deleted.");
  }
};

/* ------------------------------- website ------------------------------- */

export const getPolicies = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("policies?active=1"));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const getPolicyDetail = (slug) => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI(`policy/${slug}`));
    return response.data.data || null;
  } catch (error) {
    return null;
  }
};
